import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";

function StrukturEdit() {
    const { id_struktur } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        foto: "",
        tanggal: "",
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState({
        foto: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setSelectedFile({
                ...selectedFile,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const fetchData = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => Promise.reject(error)
            );

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/structure/readStrukturById/${id_struktur}`
            );
            const data = response.data;
            setFormValue({
                foto: data.foto,
                tanggal: data.tanggal.split("T")[0],
            });
            setPreview({ foto: data.foto });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [id_struktur, navigate]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
            if (name.startsWith("foto_")) {
                setPreview({
                    ...preview,
                    [name]: null,
                });
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const FormDataInput = new FormData();
        if (selectedFile) {
            FormDataInput.append("photo", selectedFile.foto); // Append cropped photo
        }
        FormDataInput.append("tanggal", formValue.tanggal);

        try {
            await axios.put(
                `${process.env.REACT_APP_API_URL}/structure/updateStruktur/${id_struktur}`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
            }).then(() => {
                navigate("/struktur"); // balik ke halaman struktur
            });

            setSelectedFile(null);
        } catch (error) {
            console.error("Error updating data:", error);
            Swal.fire({
                title: "Error",
                text: "Data gagal diperbarui",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Struktur Organisasi</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Struktur</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Foto</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto"
                                                        accept="image/*"
                                                        onChange={handleChange}
                                                    />
                                                    {formValue.foto && (
                                                        <div className="preview-container-galery">
                                                            <img
                                                                src={preview.foto || formValue.foto}
                                                                alt="Preview"
                                                                className="preview-image-galery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="form-group">
                                                    <label>Tanggal</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="tanggal"
                                                        onChange={handleChange}
                                                        value={formValue.tanggal}
                                                        readOnly
                                                    />
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/struktur">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default StrukturEdit;
